<template><!--可编辑input框 输入：单项绑定text，输出：编辑后的值 请自行更新text已更改显示效果-->
  <div>
    <!--effect有bug，全局dark模式下 light才是dark-->
    <el-tooltip v-if="!isEditTitle" effect="light" :content="text" placement="top" :show-after="100" :disabled="toolTipDisable">
      <p class="label" @click="editTitle(true)">{{ text }}</p> <!--这里用title会造成与外部数据不一致 与input一致造成误导-->
    </el-tooltip>
    <el-input v-else class="input" v-model="title" @blur="editTitle(false)" @keyup.enter="$refs.input.blur()" ref="input"/>
    <!--el-input只能使用双向绑定 --><!--toolTip作用于el-input会导致空格输入无效-->
  </div>
</template>

<script>
export default {
  name: "EditLabel",
  emits: ['edited'],
  data(){
    return{
      isEditTitle: false,
      title: this.text
    }
  },
  props:{
    text: String,
    toolTipDisable: Boolean
  },
  watch:{
    text(nVal){
      this.title = nVal
    }
  },
  methods:{
    editTitle(isEdit){
      this.isEditTitle = isEdit
      if(isEdit)
        this.$nextTick(() => this.$refs.input.focus())
      else if(this.title !== this.text){
        this.$emit('edited', this.title)
        this.title = this.text //复位，防止label和input不一致
      }
    }
  }
}
</script>

<style scoped>
.label{
  margin: 1px;
  cursor: pointer;
}
.input{
  /*font-size: 15pt;*/
  font-size: 0.9em;/*相对单位 相对父容器字号的0.9倍; 需要酱紫来使外部css覆盖element-UI内部的css*/
}
</style>